import { useLocale } from './locale';
import { useTranslate } from './useTranslate';

/**
 * Dil seçimi kalıcıdır ve her isteğe X-Locale olarak gider (SEOAI-65).
 * Seçenekler KATALOGDAN gelir (SEOAI-76 tek kaynak); panelde liste tutulmaz.
 */
export function LocaleSwitcher() {
  const t = useTranslate();
  const locale = useLocale((s) => s.locale);
  const catalog = useLocale((s) => s.catalog);
  const setLocale = useLocale((s) => s.setLocale);

  // Katalog gelmeden seçici gösterilmez: tek seçenekli bir liste yanıltıcı olurdu.
  if (!catalog || catalog.locales.length < 2) return null;

  return (
    <label className="switcher">
      {t('locale.label')}
      <select value={locale} onChange={(event) => setLocale(event.target.value)}>
        {catalog.locales.map((entry) => (
          <option key={entry.code} value={entry.code}>
            {entry.native}
          </option>
        ))}
      </select>
    </label>
  );
}
